import type { ReactNode } from "react";

interface AdminDataTableColumn<T> {
  key: string;
  header: string;
  render: (row: T) => ReactNode;
  className?: string;
}

interface AdminDataTableProps<T> {
  rows: T[];
  columns: Array<AdminDataTableColumn<T>>;
  getRowKey: (row: T) => string;
  emptyState: ReactNode;
}

export function AdminDataTable<T>({ rows, columns, getRowKey, emptyState }: AdminDataTableProps<T>) {
  if (rows.length === 0) return emptyState;

  return (
    <div className="overflow-hidden rounded-md border border-cyan-300/15">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-cyan-300/15">
          <thead className="bg-white/[0.03]">
            <tr>
              {columns.map((column) => (
                <th key={column.key} className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.18em] text-content-muted">
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-cyan-300/10 bg-black/20">
            {rows.map((row) => (
              <tr key={getRowKey(row)} className="transition hover:bg-cyan-300/[0.04]">
                {columns.map((column) => (
                  <td key={column.key} className={column.className ?? "px-4 py-4 align-middle text-sm text-content-secondary"}>
                    {column.render(row)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
